import { DocScripts } from "../components/widgets/codeBlock";

type LANGUAGES = 'JavaScript' | 'Python' | 'NodeJS' | 'JSON';

type ScriptEntries = 'registro';

export const usuarioScripts = {
    registro: {
        requests: [{
            language: 'JSON',
            subtitle: 'Cuerpo del request',
            subsubtitle: '(application/json)',
            code: `
{
    "name":"Gabriel Balsa",
    "email":"contacto@ejemplo.mx",
    "password":"*****",
    "phone":"+524423339876" 
}`
        }],
        response: {
            language: 'JSON',
            subtitle: 'Respuesta correcta',
            code: `
{
    "name": "Gabriel Balsa",
    "email": "contacto@ejemplo.mx",
    "password": "12345", // password regresa visible
    "phone": "+524423339876",
    "createdAt": "2018-09-06T21:11:42.264Z",
    "masterToken": "b4a52fd8-19f6-4eac-83d7-18e98f7722dd", // Tu token principal
    "planType": 0,
    "credit": 0,
    "emailValid": false
}`
        }
    } as DocScripts
}
